module.exports = __webpack_public_path__ + "img/icon_aside_word2.485eefb4.svg";